<template lang="html">

  <section class="filtro-container" id="filtroPracticas" ref="section">

    <div class="filtro-wrapper" @keyup.esc="show = false">

      <div class="top-container">

        <div class="row-between ais">

          <div class="contenedor-input quarter-slot type-text filtro-text" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>Titulación</label>
            <input type="text" @keyup="emit" v-model="selected.titulacion" :placeholder="$t('filtro_practica.buscar_titulacion')">
          </div>
       

          <div class="contenedor-input quarter-slot" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>Tipo créditos</label>
                <div class="row-start radio-wrapper">
                    <div class="radio-container">
                        <input type="radio" value="Curricular" id="Curricular" v-model="selected.tipoPractica" name="tipoPractica">
                        <label for="Curricular">Curricular</label>
                    </div>
                    <div class="radio-container">
                        <input type="radio" value="Extracurricular" id="Extracurricular" v-model="selected.tipoPractica" name="tipoPractica">
                        <label for="Extracurricular">Extracurricular</label>
                    </div>
                </div>
          </div>

          <div class="contenedor-input  quarter-slot type-text filtro-text" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>Código de asignatura</label>
            <input type="text" @keyup="emit" v-model="selected.codAsignatura" :placeholder="$t('filtro_practica.buscar_asignatura')">
          </div>

          <div class="contenedor-input quarter-slot type-text filtro-text" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>Curso</label>
            <input type="text" @keyup="emit" v-model="selected.curso" :placeholder="$t('filtro_practica.buscar_curso')">
          </div>

          <div class="contenedor-input type-text middle-slot sin-espacios" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>{{$t('filtro_practica.fecha_inicio')}}</label>
          </div>

          <div class="contenedor-input type-text middle-slot sin-espacios" v-if="$route.name != 'ofertas-practicas-tutor'">
            <label>{{$t('filtro_practica.fecha_fin')}}</label>
          </div>

          <div class="contenedor-input fecha quarter-slot" v-if="$route.name != 'ofertas-practicas-tutor'">
            <datepicker v-model="selected.f_inicio_desde" :placeholder="$t('filtro_practica.desde')" :language="(lang == 'es') ? es : ca" :full-month-name="true"
              :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'day'" name="fechaInicioDesde"></datepicker>
          </div>

          <div class="contenedor-input fecha quarter-slot" v-if="$route.name != 'ofertas-practicas-tutor'">
            <datepicker v-model="selected.f_inicio_hasta" :placeholder="$t('filtro_practica.hasta')" :language="(lang == 'es') ? es : ca" :full-month-name="true"
              :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'day'" name="fechaInicioHasta"></datepicker>
          </div>

          <div class="contenedor-input fecha quarter-slot" v-if="$route.name != 'ofertas-practicas-tutor'">
            <datepicker v-model="selected.f_fin_desde" :placeholder="$t('filtro_practica.desde')" :language="(lang == 'es') ? es : ca" :full-month-name="true"
              :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'day'" name="fechaFinDesde"></datepicker>
          </div>

          <div class="contenedor-input fecha quarter-slot" v-if="$route.name != 'ofertas-practicas-tutor'">
            <datepicker v-model="selected.f_fin_hasta" :placeholder="$t('filtro_practica.hasta')" :language="(lang == 'es') ? es : ca" :full-month-name="true"
              :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'day'" name="fechaFinHasta"></datepicker>
          </div>

          <div class="contenedor-input middle-slot type-text filtro-text" v-if="$route.name == 'ofertas-practicas-tutor'">
            <label>Nombre oferta</label>
            <input type="text" @keyup="emit" v-model="selected.puesto" :placeholder="$t('filtro_practica.buscar_puesto')">
          </div>

          <div class="contenedor-input middle-slot type-text filtro-text" v-if="$route.name == 'ofertas-practicas-tutor'">
            <label>Empresa</label>
            <input type="text" @keyup="emit" v-model="selected.nombreComercialEmpresa" :placeholder="$t('filtro_practica.buscar_empresa')">
          </div>
        </div>

      </div>
    </div>
    <section class="resumen row-between">
      <div class="tag-container row-start">

          <div class="tag" v-if="!!selected.titulacion"> 
            <span class="row-center"  @click="eraseTitulaciones" >
              <button>✕</button>
              <span>{{selected.titulacion}}</span>
            </span>
         </div>

          <div class="tag" v-if="!!selected.tipoPractica">
            <span class="row-center"  @click="eraseTipoPractica">
              <button>✕</button>
              <span>{{selected.tipoPractica}}</span>
            </span>
          </div>

          <div class="tag" v-if="!!selected.codAsignatura">
            <span class="row-center"  @click="eraseAsignatura" >
              <button>✕</button>
              <span>{{selected.codAsignatura}}</span>
            </span>
          </div>

          <div class="tag" v-if="!!selected.curso">
            <span class="row-center"  @click="eraseCurso">
              <button>✕</button>
              <span>{{selected.curso}}</span>
            </span>
          </div>

        <div class="tag" v-if="!!selected.f_inicio_desde">
          <span class="row-center"  @click="eraseFechaInicioDesde" >
            <button>✕</button>
            <span>{{formatFecha(selected.f_inicio_desde)}}</span>
          </span>
        </div>

        <div class="tag" v-if="!!selected.f_inicio_hasta">
          <span class="row-center"  @click="eraseFechaInicioHasta">
            <button>✕</button>
            <span>{{formatFecha(selected.f_inicio_hasta)}}</span>
          </span>
        </div>

        <div class="tag" v-if="!!selected.f_fin_desde">
          <span class="row-center"  @click="eraseFechaFinDesde" >
            <button>✕</button>
            <span>{{formatFecha(selected.f_fin_desde)}}</span>
          </span>
        </div>

        <div class="tag" v-if="!!selected.f_fin_hasta">
          <span class="row-center"  @click="eraseFechaFinHasta">
            <button>✕</button>
            <span>{{formatFecha(selected.f_fin_hasta)}}</span>
          </span>
        </div>

        <div class="tag" v-if="!!selected.puesto">
          <span class="row-center"  @click="erasePuesto">
            <button>✕</button>
            <span>{{selected.puesto}}</span>
          </span>
        </div>

        <div class="tag" v-if="!!selected.nombreComercialEmpresa">
          <span class="row-center"  @click="eraseNombreComercialEmpresa">
            <button>✕</button>
            <span>{{selected.nombreComercialEmpresa}}</span>
          </span>
        </div>

      </div>
    </section>    
  </section>
</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import Datepicker from 'vuejs-datepicker';

  import { ca, es } from 'vuejs-datepicker/dist/locale'

  export default  {
    name: 'filtro-practicas',
    mounted(){
      this.erasefiltros();
      this.selected = this.filtrosData;
      this.observeHeight();
    },
    props : ['data'],
    data() {
      return {
        selected : {
          titulacion: '',
          codAsignatura: '',
          tipoPractica: '',
          curso: '',
          f_inicio_desde: '',
          f_inicio_hasta: '',
          f_fin_desde: '',
          f_fin_hasta: '',
          puesto: '',
          nombreComercialEmpresa: ''
        },
        show : false,
        ca: ca,
        es: es
      }
    },
    methods : {
      ...mapActions(['requestSetFiltroPracticas']),
      emit : function(){
        this.requestSetFiltroPracticas(this.selected);
      },
      erasefiltros : function(){
        Object.keys(this.selected).forEach(key => {
          this.selected[key] = '';
        });
       
        this.emit();
      },
      eraseTitulaciones(){
        this.selected.titulacion = '';
      },
      eraseAsignatura(){
        this.selected.codAsignatura = '';
      },
      eraseTipoPractica(){
        this.selected.tipoPractica = '';
      },
      eraseCurso(){
        this.selected.curso = '';
      },
      eraseFechaInicioDesde(){
        this.selected.f_inicio_desde = '';
      },
      eraseFechaInicioHasta(){
        this.selected.f_inicio_hasta = '';
      },
      eraseFechaFinDesde(){
        this.selected.f_fin_desde = '';
      },
      eraseFechaFinHasta(){
        this.selected.f_fin_hasta = '';
      },
      erasePuesto(){
        this.selected.puesto = '';
      },
      eraseNombreComercialEmpresa(){
        this.selected.nombreComercialEmpresa = '';
      },

      formatFecha(fecha) {
        if (!fecha) return ""; 
          return new Date(fecha).toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });
      },
      observeHeight() {
        const resizeObserver = new ResizeObserver(() => {
          let mSection = this.$refs.section;
          if (mSection != null){
            this.posicionarBuscador();
          }
          
        });
        resizeObserver.observe(this.$refs.section);
      },
      posicionarBuscador(){
        let outside = document.getElementsByClassName('VueTables__search')[0];
        let altura = window.document.getElementById('filtroPracticas').offsetHeight;

        outside.style.top = -altura - 52 + 'px';
      }
      
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        filtrosData : 'getfiltrosPracticas',
        brand : 'getBrand',
        lang : 'getLanguage'
      }),
      ownstyles : function(){
        return {
          filter_button : {
            'border-left': `1px solid ${this.colors.medium_black}`
          },
        }
      }
  },
  components : {
    Datepicker
  },
  watch : {
    '$route' : 'erasefiltros',
    'selected': {
      handler(){
        this.emit();
      }
    }
  }

}
</script>

<style scoped lang="scss">

  @import '@/assets/css/colors.scss';

  .filtro-text{
    border: none;
    border-bottom: 1px solid #9b9b9b;
    padding-bottom: 0;
  }

  .loader{
    width: 100%;
    height: 10px;
    display: inline-block;
    position: absolute;
    bottom: -10px;
    left: 0;
    z-index: 1;
    transition: 1s;
    transition-delay: .2s;

    i{
      width: 100%;
      display: block;
      height: 10px;
    }

    &[hide=true]{
      transform: translateY(-20px);
    }
    
  }

  .contenedor-input input[type="checkbox"] + label, .contenedor-input input[type="radio"] + label{
    line-height: 30px;
  }

  .contenedor-botones{
    width: 100%;
    .basic{
      flex-grow: 2;
    }
  }

  .-busquedas{
    margin-top: 20px;

    span{
      position: relative;
    }

    a.busqueda{
      font-size: 13px;
      margin-top: 5px;
      text-transform: uppercase;
      font-weight: bold;
      padding-right: 25px;
      background:url(/static/img/icons/arrow-link.svg) center right/17px no-repeat;
      text-align:left;
      display: inline-block;
      padding-left: 15px;
    }
    a.edit-busquedas{
      font-weight: 300;
      text-decoration: underline;
      font-size: 12px;
      margin-top: 20px;
    }

    input{
      background: none;
      margin-bottom: 5px;
      outline: none;
    }

    .eliminar{
      border: none;
      outline: none;
      margin-right: 5px;
      cursor: pointer;
      position: absolute;
      left: 0;
      top: 5px;
    }

    .btn{
      margin-top: 10px;
    }

  }


  [dark=true] .-busquedas a.busqueda{
    background: url(/static/img/icons/arrow-link-white.svg) center right/17px no-repeat;
  }

  .popup-edit{
    max-width: 450px;
    .contenedor-input{
      margin-right: 0;
      width: 100%;
      max-width: 100%;
      padding-top: 0;
      padding-bottom: 0;
      margin-bottom: 20px;
    }

    p{
      font-style: italic;
      font-size: 14px;
    }

    .btn{
      margin-right: 10px;
      margin-left: 0;
    }
  }

  .cover-edit .titulo-popup{
    font-size: 22px;
    margin-bottom: 0;
  }

  .filtro-el{
    padding-right: 50px;
    &:nth-child(3n){
      padding-right: 0;
    }

    .contenedor-input{
      max-width: 100%;
    }
  }

  .font-normal{
    font-weight: normal;
  }

  .sin-espacios{
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  @media screen and (max-width: 930px){
      .filtro-el{
        width: 33.3333333%;
      }
  }

  @media screen and (max-width: 767px){
      .filtro-el{
        width: 50%;
      }
  }

  @media screen and (max-width: 580px){

    .contenedor-botones{
      justify-content: flex-start;
    }

    .contenedor-botones .basic{
      width: 100%;
      justify-content: flex-start;
      margin-top: 20px;
    }

      .filtro-el{
        width: 100%;
      }
      .filtro-container .filtro-el.-toggles{
        margin-top: 0;
      }

      .cover-edit .titulo-popup{
        font-size: 16px;
      }

       .filtro-container .cover-edit .contenedor-botones .btn{
        margin-bottom: 0;
        padding: 0 20px;
        min-width: 100px;
      }

       .filtro-container .cover-edit .contenedor-botones{
        margin-top: 0;
      }

  }

  
</style>



// WEBPACK FOOTER //
// src/components/views/filtro-practicas.vue